import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, SectionElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type SectionProps = RecursivePartial<SectionElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | SectionElement["children"];
  data?: SectionElement["data"];
};

export function Section(props: SectionProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: SectionElement = {
    type: BasicType.SECTION,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
